








import { Vue, Component } from 'vue-property-decorator'
import { ElementMixin } from 'vue-slicksort';

@Component({
  mixins: [ ElementMixin ]
})
export default class SlickListItem extends Vue {
}
